<template>
    <div>
        <v-dialog 
            v-model="display"
            persistent
            scrollable
            :width="1250">
            <v-card flat>
                <v-toolbar flat color="primary" dense dark class="mb-4">
                    <v-toolbar-title>
                        {{ $t('simulate_entry') }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <p-icon-btn icon="mdi-printer" @click="openPrintDialog" tooltip="Print"></p-icon-btn>
                </v-toolbar>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-simple-table dense>
                                <tbody>
                                    <tr>
                                        <th>{{ $t('date') }}</th>
                                        <td>{{ entry.date }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('document_date') }}</th>
                                        <td>{{ entry.date}}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                        <v-col>
                            <v-simple-table dense>
                                <tbody>
                                    <tr>
                                        <th>{{ $t('reference_no') }}</th>
                                        <td>{{ entry.reference_code }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('reference_type') }}</th>
                                        <td>{{ entry.reference_type }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                    <br>
                    <v-simple-table
                        dense>
                        <thead>
                            <tr>
                                <!-- <th>#</th> -->
                                <th>{{ $t('account') }}</th>
                                <th>{{ $t('narration') }}</th>
                                <th>{{ $t('debit') }} ({{baseCurrency}})</th>
                                <th>{{ $t('credit') }} ({{baseCurrency}})</th>
                                <th>{{ $t('dimension') }}</th>
                                <!-- <th>{{ $t('debit') }} ({{transCurrency}})</th>
                                <th>{{ $t('credit') }} ({{transCurrency}})</th>
                                <th>Rate Calculation</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(line, index) in entry.lines" :key="index">
                                <!-- <td>{{ index + 1 }}</td> -->
                                <td>{{ line.account_name }}</td>
                                <td><span style="white-space: pre;">{{ line.narration }}</span></td>
                                <td>{{ formatPrice(line.base_debit) }}</td>
                                <td>{{ formatPrice(line.base_credit) }}</td>
                                <td>{{ line.dimension_name }}</td>
                                <!-- <td>{{ formatPrice(line.debit) }}</td>
                                <td>{{ formatPrice(line.credit) }}</td>
                                <td>Rate</td> -->
                            </tr>
                            <tr class="font-weight-black">
                                <!-- <td></td> -->
                                <td></td>
                                <td>{{ $t('total') }}</td>
                                <td>{{ formatPrice(totalDebit) }}</td>
                                <td>{{ formatPrice(totalCredit) }}</td>
                                <td colspan="3"></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <br>
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>{{ $t('narration') }}</th>
                                <td>{{ entry.narration }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        v-if="!isPosted" 
                        :disabled="!canPost"
                        :loading="isPosting"
                        color="primary"
                        @click="confirmPosting"
                        text>
                        {{ $t('post_to_ledges') }}
                    </v-btn>
                    <v-btn 
                        @click="display = false" 
                        text>
                        {{ $t('close_btn') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <simulate-entries-print
            v-model="printDialogShown"
            :simulate="entry">
        </simulate-entries-print>
        <p-alert
            v-if="alert.display"
            v-model="alert.display"
            :title="alert.title"
            :content="alert.content"
            :callback="alert.callback">
        </p-alert>
    </div>
</template>

<script>
import { formatMoney } from 'accounting';

import SimulateEntriesPrint from './SimulateEntriesPrint.vue';
import PIconBtn from '../common/PIconBtn.vue';
import PAlert from '../common/PAlert.vue';
import { getTotal } from '../../utils/accounting';
import isArabic from './../../utils/isArabic.js'

export default {
    name: 'SimulateEntries',
    props: {
        entry: {
            type: Object,
            required: true
        },
        value: Boolean,
        isPosted: Boolean,
        canPost: Boolean,
        isPosting: Boolean
    },
    data() {
        return {
            printDialogShown: false,
            alert: {},
            baseCurrency: "SDG",
            transCurrency: "USD"
        }
    },
    components: { SimulateEntriesPrint, PIconBtn, PAlert },
    computed: {
        display: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        },
        totalDebit() {
            return getTotal(this.entry.lines, "base_debit");
        },
        totalCredit() {
            return getTotal(this.entry.lines, "base_credit");
        },
    },
    methods: {
        isArabic,
        formatPrice(amount) {
            return formatMoney(amount, " ", 2);
        },
        openPrintDialog() {
            this.printDialogShown = true;
        },
        openAlertDialog({title, content, callback}) {
            this.alert = {...this.alert, display: true, title, content, callback};
        },
        confirmPosting() {
            this.openAlertDialog({
                title: "Confirm Posting",
                content: "Are you sure you want to post this document? This process cannot be undone!",
                callback: this.submit
            })
        },
        submit() {
            this.$emit("post");
        }
    }
}
</script>

<style>

</style>